import React from "react";
import { Autocomplete, Box, TextField } from "@mui/material";

// Scope type filter — single-select. "All" means no `type` query param is
// sent to the backend, so it is represented by the empty value.
export const SCOPE_TYPE_OPTIONS = [
    { value: "", label: "All" },
    { value: "design", label: "Design" },
    { value: "execution", label: "Execution" },
];

export default function ScopeTypeFilter({ value = "", onChange }) {
    const selectedOption =
        SCOPE_TYPE_OPTIONS.find((opt) => opt.value === value) ||
        SCOPE_TYPE_OPTIONS[0];

    return (
        <Box sx={{ width: "100%" }}>
            <Autocomplete
                disableClearable
                options={SCOPE_TYPE_OPTIONS}
                value={selectedOption}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(opt, val) => opt.value === val.value}
                onChange={(_, newOption) => {
                    onChange(newOption?.value || "");
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder="Scope Type"
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "8px",
                                backgroundColor: "#F5F6F8",
                                fontFamily: "Inter Tight",
                                fontSize: 14,
                                padding: "4px 8px !important",
                                "& fieldset": {
                                    border: "none",
                                },
                                "&:hover fieldset": {
                                    border: "none",
                                },
                                "&.Mui-focused fieldset": {
                                    border: "none",
                                },
                            },
                        }}
                    />
                )}
            />
        </Box>
    );
}
